import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { LandingPage } from "./index";

type LoginSearch = {
  returnUrl?: string;
};

export const Route = createFileRoute("/login")({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    returnUrl: typeof search.returnUrl === "string" ? search.returnUrl : undefined,
  }),
  component: LoginPage,
});

function LoginPage() {
  const navigate = useNavigate();
  const { returnUrl } = Route.useSearch();

  return (
    <LandingPage
      initialAuthOpen
      authReturnUrl={returnUrl ?? "/dashboard"}
      onAuthOpenChange={(open) => {
        if (!open) void navigate({ to: "/" });
      }}
    />
  );
}
